import React, { useState } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import moment from 'moment';
import editIcon from '../../../../assets/allInvoice-assets/edit.svg';
import Eye from '../../../../assets/allInvoice-assets/eye.svg';
import CheckIcon from '../../../../assets/allInvoice-assets/check.svg';
import CloseIcon from '../../../../assets/allInvoice-assets/x.svg';
import CustomTooltip from '../../utils/CustomTooltip';
import { lightPalette } from '../../../../theme';
import { classes } from './utils';
import CheckCircle from '../../../../assets/allInvoice-assets/check-circle.svg';
import trash from '../../../../assets/allInvoice-assets/trash-2.svg';
import ConfirmDialog from '../../utils/ConfirmDialog';
import {
  deleteOneVersion,
  renameVersion,
} from '../../../../services/versionApi';
import Toast from '../../utils/Toast';
import { globalClasses } from '../../utils/globalUtils';
import { DOCUMENT_ACTION_TOOLTIP } from '../../../../constants/tooltipConstant';
import MODELS from '../../../../constants/models';

const VersionNameRow = (params) => {
  const id = params?.data?.invoice_id;
  const isDeleted = params?.data?.Deleter;
  const versionName = params?.data?.version;
  const documentType = params?.data?.invoice?.document_type;
  let documentTypeString;
  switch (documentType) {
    case MODELS.INVOICE:
      documentTypeString = 'invoice';
      break;
    case MODELS.RECEIPT:
      documentTypeString = 'receipt';
      break;
    case MODELS.SALES:
      documentTypeString = 'sale';
      break;
    case MODELS.CREDIT_CARD_STATEMENT:
      documentTypeString = 'creditcardstatement';
      break;
    case MODELS.BANK_STATEMENT:
      documentTypeString = 'bank-statement';
      break;

    default:
      documentTypeString = 'unknown';
  }

  const onClickEditInvoice = () => {
    params?.api.startEditingCell({
      rowIndex: params?.rowIndex,
      colKey: 'version',
    });
  };

  const basePath = `/${documentTypeString}`;
  const toPath =
    params?.rowIndex !== 0
      ? `${basePath}/${versionName}/${id}`
      : `${basePath}/${id}`;

  if (params?.value !== undefined) {
    return (
      <Box className={classes.documentRowMainBox}>
        <Box className={classes.documentNameBox}>
          {isDeleted === null ? (
            <Link to={toPath} className="linkStyle">
              <Typography
                variant="body1"
                fontWeight="400"
                className={classes.documentRowTypography}
              >
                {params?.value}
              </Typography>
            </Link>
          ) : (
            <Typography
              variant="body1"
              fontWeight="400"
              className={`${classes.documentRowTypography} ${classes.documentRowTypographyColor}`}
            >
              {params?.value}
            </Typography>
          )}
        </Box>
        <Box>
          <Box className={`my-icon ${classes.editIconBox}`}>
            <Box
              component="img"
              src={editIcon}
              alt="Edit"
              className={classes.editIcon}
              onClick={onClickEditInvoice}
            />
          </Box>
        </Box>
      </Box>
    );
  }
};

const CustomCellEditor = (params) => {
  const [currentValue, setCurrentValue] = useState(params?.value);
  const invoiceId = params?.data?.invoice_id;
  const versionId = params?.data?.id;

  const handleRenameDocument = (versionName) => {
    const node = params?.api.getRowNode(versionId);
    node.data.version = versionName;
    node.updateData({ ...node.data });
  };
  const UpdateColumn = async (item) => {
    try {
      const response = await renameVersion(invoiceId, versionId, item);
      if (response) {
        handleRenameDocument(item);
        params?.api.stopEditing();
        Toast({
          message: response?.data?.message,
          variant: 'success',
        });
      }
      return response;
    } catch {
      params?.api.stopEditing();
    }
  };
  const handleRightOption = async () => {
    UpdateColumn(currentValue);
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setCurrentValue(event.target.value);
      UpdateColumn(event.target.value);
    }
  };
  const handleWrongOption = () => {
    params?.api.stopEditing();
  };
  const handleTextFieldFocus = () => {
    const textField = document.querySelector('.editCellTextfield'); // Adjust selector as needed
    textField.addEventListener('keydown', handleKeyDown);
  };

  return (
    <Box className={classes.documentEditCellBox}>
      <TextField
        fullWidth
        value={currentValue}
        onChange={(event) => setCurrentValue(event.target.value)}
        className={classes.editCellTextfield}
        onFocus={handleTextFieldFocus}
      />
      <Box className={classes.editCellActionIcons}>
        <Box
          component="img"
          src={CheckIcon}
          alt="CheckIcon"
          className={`${classes.editIcon} ${params?.data.version !== currentValue ? globalClasses.visible : globalClasses.notVisibility}`}
          onClick={handleRightOption}
        />
        <Box
          component="img"
          src={CloseIcon}
          alt="CloseIcon"
          className={classes.editIcon}
          onClick={handleWrongOption}
        />
      </Box>
    </Box>
  );
};

const VersionCreatorName = (params) => {
  const FIRST_NAME = params?.data?.Creator?.first_name;
  const LAST_NAME = params?.data?.Creator?.last_name;
  if (params?.data) {
    return (
      <Typography
        variant="body1"
        color={lightPalette.lunarBase.main}
        fontWeight="400"
      >
        {FIRST_NAME && LAST_NAME ? `${FIRST_NAME} ${LAST_NAME}` : '-'}
      </Typography>
    );
  }
};

const UpdaterName = (params) => {
  const FIRST_NAME = params?.data?.Updater?.first_name;
  const LAST_NAME = params?.data?.Updater?.last_name;

  if (params?.data) {
    return (
      <Typography
        variant="body1"
        color={lightPalette.lunarBase.main}
        fontWeight="400"
      >
        {FIRST_NAME && LAST_NAME ? `${FIRST_NAME} ${LAST_NAME}` : '-'}
      </Typography>
    );
  }
};

const versionDate = (params) => {
  const { value } = params;
  const formattedDate = moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');
  const date = moment(value).fromNow();

  if (params?.data) {
    return (
      <Box>
        {value !== undefined && value !== null ? (
          <CustomTooltip title={formattedDate}>
            <Typography variant="body1" fontWeight="400">
              {date}
            </Typography>
          </CustomTooltip>
        ) : (
          <Box className={classes.dateValueBox}>
            <Typography>-</Typography>
          </Box>
        )}
      </Box>
    );
  }
};

const IconRenderer = (params) => {
  const id = params?.data?.invoice_id;
  const versionId = params?.data?.id;
  const versionName = params?.data?.version;
  const documentType = params?.data?.invoice?.document_type;
  const handleApiCompletion = () => {
    params?.api.purgeInfiniteCache();
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const askingMessage = `Are You Sure You Want to Delete This Version : ${params?.data?.version} ?`;

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirmAction = async () => {
    if (id !== null) {
      const response = await deleteOneVersion(id, versionId);
      if (response) {
        Toast({ message: `${response.data.message}`, variant: 'success' });
        handleApiCompletion();
      }
    }

    handleCloseDialog();
  };

  let basePath;
  switch (documentType) {
    case MODELS.INVOICE:
      basePath = '/invoice';
      break;
    case MODELS.RECEIPT:
      basePath = '/receipt';
      break;
    case MODELS.SALES:
      basePath = '/sale';
      break;
    case MODELS.CREDIT_CARD_STATEMENT:
      basePath = '/creditcardstatement';
      break;
    case MODELS.BANK_STATEMENT:
      basePath = '/bank-statement';
      break;
    default:
      basePath = 'invoice';
  }
  const fullPath =
    params?.rowIndex !== 0
      ? `${basePath}/${versionName}/${id}?editing=true`
      : `${basePath}/${id}`;

  return (
    <Box>
      <Box
        className={`${globalClasses.displayFlex} ${globalClasses.displayAlignItem} ${classes.editIconBox}`}
      >
        {params?.rowIndex !== 0 ? (
          <Link to={`${basePath}/${versionName}/${id}`}>
            <Box className="my-icon">
              <CustomTooltip title={DOCUMENT_ACTION_TOOLTIP.VIEW}>
                <Box
                  component="img"
                  src={Eye}
                  alt="view"
                  className={classes.actionIcons}
                />
              </CustomTooltip>
            </Box>
          </Link>
        ) : null}
        <Link to={fullPath}>
          <Box className="my-icon">
            <CustomTooltip title={DOCUMENT_ACTION_TOOLTIP.VALIDATE}>
              <Box
                component="img"
                src={CheckCircle}
                alt="check-circle"
                className={classes.actionIcons}
              />
            </CustomTooltip>
          </Box>
        </Link>
        {params?.rowIndex !== 0 ? (
          <Box className="my-icon">
            <CustomTooltip title={DOCUMENT_ACTION_TOOLTIP.DELETE}>
              <Box
                component="img"
                src={trash}
                alt="trash"
                className={classes.actionIcons}
                onClick={() => handleOpenDialog()}
              />
            </CustomTooltip>
          </Box>
        ) : null}
        {isDialogOpen ? (
          <ConfirmDialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmAction}
            askingMessage={askingMessage}
            isStatusCompleted={undefined}
          />
        ) : null}
      </Box>
    </Box>
  );
};

const versionColumnDef = (gridSettingData, gridKey) => [
  {
    headerName: 'Version Name',
    field: 'version',
    headerComponent: 'ResponsiveSortingHeader',
    headerComponentParams: {
      gridSettingData,
      gridKey,
    },
    minWidth: 250,
    maxWidth: 350,
    sortable: true,
    editable: true,
    cellRenderer: VersionNameRow,
    cellEditor: CustomCellEditor,
    pinned: 'left',
    lockPinned: true,
    lockPosition: true,
    filter: true,
    suppressMenu: true,
    type: 'text',
    filterParams: {
      filterOptions: ['contains'],
      buttons: ['reset', 'apply'],
      suppressAndOrCondition: true,
      closeOnApply: true,
    },
    hide: false,
  },
  {
    headerName: 'Created By',
    field: 'created_by',
    headerComponent: 'ResponsiveSortingHeader',
    headerComponentParams: {
      gridSettingData,
      gridKey,
    },
    sortable: true,
    minWidth: 120,
    maxWidth: 220,
    cellRenderer: VersionCreatorName,
    filter: true,
    suppressMenu: true,
    type: 'text',
    filterParams: {
      filterOptions: ['contains'],
      buttons: ['reset', 'apply'],
      suppressAndOrCondition: true,
      closeOnApply: true,
    },
  },
  {
    headerName: 'Created At',
    field: 'created_at',
    headerComponent: 'ResponsiveSortingHeader',
    headerComponentParams: {
      gridSettingData,
      gridKey,
    },
    sortable: true,
    minWidth: 120,
    maxWidth: 220,
    cellRenderer: versionDate,
    filter: 'agDateColumnFilter',
    type: 'date',
    suppressMenu: true, // Hides the filter icon
    filterParams: {
      filterOptions: ['inRange'],
      buttons: ['reset', 'apply'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      // minValidDate: formattedMinDate,
      // maxValidDate: todayString,
      comparator: (filterDate, cellValue) => {
        const cellDate = new Date(cellValue);
        if (cellDate < filterDate) return -1;
        if (cellDate > filterDate) return 1;
        return 0;
      },
    },
  },
  {
    headerName: 'Updated By',
    field: 'updated_by',
    headerComponent: 'ResponsiveSortingHeader',
    headerComponentParams: {
      gridSettingData,
      gridKey,
    },
    sortable: true,
    minWidth: 120,
    maxWidth: 220,
    cellRenderer: UpdaterName,
    filter: true,
    suppressMenu: true,
    type: 'text',
    filterParams: {
      filterOptions: ['contains'],
      buttons: ['reset', 'apply'],
      suppressAndOrCondition: true,
      closeOnApply: true,
    },
  },
  {
    headerName: 'Updated At',
    field: 'updated_at',
    headerComponent: 'ResponsiveSortingHeader',
    headerComponentParams: {
      gridSettingData,
      gridKey,
    },
    sortable: true,
    minWidth: 120,
    maxWidth: 220,
    cellRenderer: versionDate,
    filter: 'agDateColumnFilter',
    type: 'date',
    suppressMenu: true, // Hides the filter icon
    filterParams: {
      filterOptions: ['inRange'],
      buttons: ['reset', 'apply'],
      suppressAndOrCondition: true,
      closeOnApply: true,
      // minValidDate: formattedMinDate,
      // maxValidDate: todayString,
      comparator: (filterDate, cellValue) => {
        const cellDate = new Date(cellValue);
        if (cellDate < filterDate) return -1;
        if (cellDate > filterDate) return 1;
        return 0;
      },
    },
  },
  {
    headerName: ' ',
    field: ' ',
    minWidth: 100,
    cellRenderer: IconRenderer,
  },
];

export default versionColumnDef;
